import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Fstyr } from './Fstyr';


export class FstyrSelectableTable extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mappedData: [[]],
            rowsSelected: [],
            rowDataSelected: [],
            rowRefs: [],
        };
    }

    handleCheckBoxInput(id, dataRow) {
        var checkbox = document.getElementById(this.props.tableName + "-cb-" + id);
        if (checkbox === undefined) {
            return;
        }
        if (this.props.noDeselection) {
            checkbox.checked = true
        }
        if (this.props.onRowSelected) {
            if (checkbox.checked) {
                this.props.onRowSelected(dataRow);
            } else {
                this.props.onRowSelected(null);
            }
        }
        for (var i = 0; i < this.props.data.length; i++) {
            checkbox = document.getElementById(this.props.tableName + "-cb-" + i);
            if (checkbox.id !== this.props.tableName + "-cb-" + id) {
                checkbox.checked = false
            }
        }
    }


    preSelect() {
        var checkbox = document.getElementById(this.props.tableName + "-cb-" + 0);
        if (checkbox) {
            checkbox.checked = true;
            if (this.props.onRowSelected) {
                this.props.onRowSelected(this.props.data[0])
            };
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            if (this.props.preSelect && prevProps.data.length === 0 && this.props.data.length > 0) this.preSelect();
        }
    }

    getPath(p) {
        if (p === "driverCard") {
            return "/drivercard/searchcard/"
        }
        else if (p === "workshopCard") {
            return "/workshopcard/searchworkshopcard/"
        }
        else if (p === "businessCard") {
            return "/businesscard/searchbusinesscard/"
        }
        return ""
    }

    checkDisabled(i) {
        if (this.props.disableAll) return true;
        if (this.props.useCustomDisableCheckboxFunction) return this.props.disableCheckbox(i)
        return false;
    }

    render() {

        return (
            <div className="fstyr-table-responsive-scroll">
                <p className="fstyr-table-title" >{this.props.label}</p>
                <table className="fstyr-table table">
                    <thead>
                        <tr>
                            <th></th>
                            {this.props.headers.map((header) =>
                                <th key={header}>{header}</th>
                            )}
                        </tr>
                    </thead>
                    <tbody style={{ padding: "10px" }}>
                        {
                            this.props.data.map((dataRow, i) =>
                                <tr key={i}>
                                    <td>
                                        <Fstyr.Checkbox
                                            name="checkbox"
                                            id={this.props.tableName + "-cb-" + i}
                                            onClick={() => { this.handleCheckBoxInput(i, dataRow) }}
                                            disabled={this.checkDisabled(i) || (this.props.de)}
                                        />
                                    </td>
                                    {dataRow.map((cellData, j) => {
                                        return (
                                            (j === 0 && this.props.useLinks) ? //check om kortnummerfelt skal være link
                                                <td key={i + "-" + j}>
                                                    <Link target="_blank" to={this.getPath(this.props.path) + cellData} params={{}}>{cellData}</Link>
                                                </td>
                                                :
                                                <td key={i + "-" + j}>{cellData}</td>
                                        )
                                    }
                                    )}
                                </tr>
                            )
                        }
                    </tbody>
                </table>
                <p className="fstyr-table-note" >{this.props.note}</p>

            </div>

        );
    }


}